import Cookies from 'js-cookie';
import { DEFAULT_THEME_MODE, THEME_MODE_COOKIE_NAME, THEME_MODE_COOKIE_OPTIONS } from './constants';
import { type ThemeMode } from './types';

const THEME_MODES: readonly ThemeMode[] = ['light', 'dark', 'system'];

export const isThemeMode = (value: unknown): value is ThemeMode =>
    typeof value === 'string' && (THEME_MODES as readonly string[]).includes(value);

const parseThemeMode = (value: string | undefined | null): ThemeMode | undefined => {
    if (isThemeMode(value)) {
        return value;
    }

    return undefined;
};

export const readThemeModeCookie = (): ThemeMode =>
    parseThemeMode(Cookies.get(THEME_MODE_COOKIE_NAME)) ?? DEFAULT_THEME_MODE;

export const writeThemeModeCookie = (mode: ThemeMode): void => {
    const hostname = window.location.hostname;
    // Для локальной разработки записываем cookie на текущий хост.
    const domain = __IS_DEV__ ? hostname : hostname.split('.').slice(1).join('.');

    Cookies.set(THEME_MODE_COOKIE_NAME, mode, { ...THEME_MODE_COOKIE_OPTIONS, domain });
};

export const parseThemeModeFromCookieValue = (value: unknown): ThemeMode =>
    parseThemeMode(typeof value === 'string' ? value : undefined) ?? DEFAULT_THEME_MODE;
